<script setup lang="ts">
import { ref, onMounted, watch, nextTick } from 'vue'
import { useRoute, RouterLink } from 'vue-router'

const route = useRoute()
const isMenuOpen = ref(false)

const navigation = [
  { name: 'Home', href: '/' },
  { name: 'Solutions', href: '/solutions' },
  { name: 'About Us', href: '/about-us' },
  { name: 'Work with us', href: '/work-with-us' },
  { name: 'Get in touch', href: '/get-in-touch' },
]

const logoUrl = new URL('../assets/logo/logo.svg', import.meta.url).href

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value
}

// Sliding indicator logic
const navLinks = ref<any[]>([])
const indicatorStyle = ref({
  width: '0px',
  left: '0px',
  opacity: '0'
})

const updateIndicator = () => {
  nextTick(() => {
    // Find the link that matches the current route
    const activeLink = navLinks.value.find(linkEl => {
      const el = linkEl?.$el || linkEl
      return el?.getAttribute('href') === route.path
    })

    if (activeLink) {
      const el = activeLink.$el || activeLink
      indicatorStyle.value = {
        width: `${el.offsetWidth}px`,
        left: `${el.offsetLeft}px`,
        opacity: '1'
      }
    } else {
      indicatorStyle.value.opacity = '0'
    }
  })
}

onMounted(updateIndicator)
watch(() => route.path, updateIndicator)

const handleLinkHover = (e: MouseEvent) => {
  const target = e.currentTarget as HTMLElement
  indicatorStyle.value = {
    width: `${target.offsetWidth}px`,
    left: `${target.offsetLeft}px`,
    opacity: '1'
  }
}

const handleNavMouseLeave = () => {
  updateIndicator()
}
</script>

<template>
  <header class="header">
    <div class="container flex items-center justify-between">
      <RouterLink to="/" class="flex items-center logo">
        <img :src="logoUrl" alt="Voxbet" />
      </RouterLink>

      <!-- Desktop Nav -->
      <nav class="desktop-nav relative hidden lg:block" @mouseleave="handleNavMouseLeave">
        <ul class="flex items-center gap-10 list-none m-0 p-0">
          <li v-for="item in navigation" :key="item.name">
            <RouterLink 
              :to="item.href"
              ref="navLinks"
              @mouseenter="handleLinkHover"
            >
              {{ item.name }}
            </RouterLink>
          </li>
        </ul>
        <!-- Sliding Underline -->
        <div class="nav-indicator" :style="indicatorStyle"></div>
      </nav>

      <!-- Mobile Toggle -->
      <button 
        class="mobile-toggle relative z-[1100] lg:hidden" 
        :class="{ 'open': isMenuOpen }" 
        @click="toggleMenu"
        aria-label="Toggle navigation menu"
      >
        <span class="hamburger-line line-1"></span>
        <span class="hamburger-line line-2"></span>
        <span class="hamburger-line line-3"></span>
      </button>
    </div>

    <!-- Mobile Nav -->
    <Transition name="slide">
      <nav v-if="isMenuOpen" class="mobile-nav">
        <ul class="flex flex-col gap-6 text-center list-none p-0">
          <li v-for="item in navigation" :key="item.name">
            <RouterLink :to="item.href" @click="isMenuOpen = false">{{ item.name }}</RouterLink>
          </li>
        </ul>
      </nav>
    </Transition>
  </header>

</template>


